<article itemscope itemtype="http://schema.org/EducationalOrganization" itemprop="alumniOf">
  <h4 class="education-view__title">
    <span *ngIf="model.name" class="education-view__name">{{ model.name }}</span>
    <span *ngIf="model.name && model.school">- </span>
    <span itemprop="name" *ngIf="model.school" class="education-view__school-name">{{ model.school.name }}</span>
  </h4>

  <div class="education-view">
    <span class="education-view__period">
      {{ model.startYear }} - {{ model.ongoing ? '' : model.endYear }}
      <ng-container *ngIf="model.ongoing" i18n>Maintenant</ng-container>
    </span>

    <span class="education-view__degree" *ngIf="model.degree">
      <app-svg-icon
        class="education-view__icon"
        icon="job"
        label="Type de diplôme"
        i18n-label
        width=".875em"
      ></app-svg-icon>

      {{ model.degree.title }}
    </span>

    <span class="education-view__school-location" *ngIf="model.school?.location?.short">
      <app-svg-icon
        class="education-view__icon"
        icon="localisation"
        label="Lieu de formation"
        i18n-label
        width=".75em"
      ></app-svg-icon>

      <span>{{ model.school?.location?.short }}</span>
    </span>

    <span class="education-view__domains">
      <app-svg-icon class="education-view__icon" icon="tag" label="Spécialités" i18n-label width=".75em"></app-svg-icon>

      <ng-container *ngFor="let domain of model.domains; trackBy: trackByDomain; let last = last">
        <app-i18n-domain [model]="domain"></app-i18n-domain><ng-container *ngIf="!last">, </ng-container>
      </ng-container>
    </span>

    <span class="education-view__description">{{ model.description }}</span>
  </div>
</article>
